export const IMPORT_BANK_STATEMENT_REQUEST  = 'IMPORT_BANK_STATEMENT_REQUEST';
export const IMPORT_BANK_STATEMENT_SUCCESS  = 'IMPORT_BANK_STATEMENT_SUCCESS';
export const IMPORT_BANK_STATEMENT_REQUEST_FAILURE  = 'IMPORT_BANK_STATEMENT_REQUEST_FAILURE';